"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultList = void 0;
var tslib_1 = require("tslib");
var pluralize_1 = (0, tslib_1.__importDefault)(require("pluralize"));
var react_1 = (0, tslib_1.__importStar)(require("react"));
var react_use_hoverintent_1 = require("react-use-hoverintent");
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var theme_1 = require("../../../theme");
var colors_1 = require("../../../theme/colors");
var box_1 = require("../../box");
var button_1 = require("../../button");
var checkbox_input_1 = require("../../checkbox-input");
var flexbox_1 = require("../../flexbox");
var icon_button_1 = require("../../icon-button");
var padding_1 = require("../../padding");
var text_1 = require("../../text");
var text_link_1 = require("../../text-link");
function SearchResultList(props) {
    var results = props.results, onSelect = props.onSelect, formatter = props.formatter, renderOptions = props.renderOptions, maxHeight = props.maxHeight, selectedItems = props.selectedItems, footerAction = props.footerAction, disabledHoverText = props.disabledHoverText;
    var _a = (0, react_1.useState)(selectedItems), tempSelected = _a[0], setTempSelected = _a[1];
    var onSelectValue = function (value, option) {
        var _a;
        if (tempSelected[option.key]) {
            var selectedNew = (0, tslib_1.__assign)({}, tempSelected);
            delete selectedNew[option.key];
            setTempSelected(selectedNew);
        }
        else {
            setTempSelected((0, tslib_1.__assign)((0, tslib_1.__assign)({}, tempSelected), (_a = {}, _a[option.key] = value, _a)));
        }
    };
    var _b = (0, react_use_hoverintent_1.useHoverIntent)({
        timeout: 100,
    }), isHovering = _b[0], ref = _b[1];
    var wrapRef = ref;
    var renderNotFound = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(padding_1.Padding, { size: 20 },
                react_1.default.createElement(text_1.Text, null,
                    react_1.default.createElement("span", { "data-testid": "not-found" }, "Nothing found"))),
            footerAction && (react_1.default.createElement(FooterRow, null,
                react_1.default.createElement("div", null, footerAction)))));
    };
    var searchResultOptions = results &&
        results.map(function (item) {
            var option = formatter(item);
            var key = option.key, testId = option.testId;
            var Component = renderOptions(item);
            return (react_1.default.createElement("div", { key: key },
                react_1.default.createElement(StyledRow, { "data-testid": testId, isDisabled: item.isDisabled, className: "".concat(isHovering && item.isDisabled ? 'hover' : ''), ref: wrapRef },
                    react_1.default.createElement(flexbox_1.Flexbox, { alignItems: "center" },
                        react_1.default.createElement(padding_1.Padding, { x: 16 },
                            react_1.default.createElement(checkbox_input_1.CheckboxInput, { onChange: function () {
                                    if (!item.isDisabled) {
                                        onSelectValue(item, option);
                                    }
                                }, checked: !!tempSelected[key], disabled: item.isDisabled }))),
                    react_1.default.createElement("div", null, Component)),
                isHovering && item.isDisabled && disabledHoverText && (react_1.default.createElement(box_1.Box, { style: {
                        background: "".concat(colors_1.colors.steel[500]),
                        position: 'absolute',
                        right: -254,
                        top: 'calc(50%)',
                        zIndex: theme_1.zIndices.overlay,
                        borderRadius: '6px',
                        width: 250,
                    } },
                    react_1.default.createElement(padding_1.Padding, { size: 8 },
                        react_1.default.createElement(flexbox_1.Flexbox, { alignItems: "center", gap: 8 },
                            react_1.default.createElement(icon_button_1.IconButton, { disabled: true, color: "white", type: "circleInformation" }),
                            react_1.default.createElement(text_1.Text, { truncate: true, color: "white" }, disabledHoverText)))))));
        });
    return (react_1.default.createElement(box_1.Box, { style: {
            background: 'white',
            position: 'absolute',
            left: 0,
            right: 0,
            top: 'calc(100% + 4px)',
            zIndex: theme_1.zIndices.overlay,
        }, border: 1, borderRadius: 4, boxShadow: "card", testId: "result-list" }, results && results.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SummaryRow, null,
            react_1.default.createElement(flexbox_1.Flexbox, { gap: 10 },
                react_1.default.createElement(text_1.Text, { color: colors_1.colors.steel[500] },
                    Object.keys(tempSelected).length,
                    " selected"),
                Object.keys(tempSelected).length ? (react_1.default.createElement(text_link_1.TextLink, { underline: false, underlineOnHover: true, onClick: function () { return setTempSelected({}); } }, "Unselect all")) : null),
            react_1.default.createElement(text_1.Text, { color: colors_1.colors.steel[400] },
                (0, pluralize_1.default)('result', results.length, true),
                " found")),
        react_1.default.createElement(StyledResults, { maxHeight: maxHeight },
            react_1.default.createElement("span", { "data-testid": "search-results" }, searchResultOptions)),
        react_1.default.createElement(FooterRow, null,
            react_1.default.createElement("div", null, footerAction || null),
            react_1.default.createElement(flexbox_1.Flexbox, { gap: 20, alignItems: "center" },
                react_1.default.createElement(button_1.Button, { onClick: function () { return onSelect(tempSelected); } }, "Confirm selection"))))) : (renderNotFound())));
}
exports.SearchResultList = SearchResultList;
var hoverStyles = "\n  &:hover {\n    background-color: ".concat(colors_1.colors.steel[50], ";\n    cursor: pointer;\n  }\n");
var StyledRow = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n  display: flex;\n\n  &:first-child {\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  ", "\n"], ["\n  background-color: ", ";\n  border-bottom: 1px solid ", ";\n  display: flex;\n\n  &:first-child {\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n  }\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  ", "\n"])), function (_a) {
    var isDisabled = _a.isDisabled;
    return (isDisabled ? "".concat(colors_1.colors.steel[50]) : 'none');
}, colors_1.colors.steel[100], hoverStyles);
var SummaryRow = styled_components_1.default.div(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  height: 50px;\n  border-bottom: 1px solid ", ";\n  display: flex;\n  justify-content: space-between;\n  padding: 16px;\n  align-items: center;\n  box-sizing: border-box;\n"], ["\n  height: 50px;\n  border-bottom: 1px solid ", ";\n  display: flex;\n  justify-content: space-between;\n  padding: 16px;\n  align-items: center;\n  box-sizing: border-box;\n"])), colors_1.colors.border.default);
var FooterRow = styled_components_1.default.div(templateObject_3 || (templateObject_3 = (0, tslib_1.__makeTemplateObject)(["\n  height: 70px;\n  border-top: 1px solid ", ";\n  display: flex;\n  justify-content: space-between;\n  padding: 16px;\n  align-items: center;\n  box-sizing: border-box;\n"], ["\n  height: 70px;\n  border-top: 1px solid ", ";\n  display: flex;\n  justify-content: space-between;\n  padding: 16px;\n  align-items: center;\n  box-sizing: border-box;\n"])), colors_1.colors.border.default);
var StyledResults = styled_components_1.default.div(templateObject_4 || (templateObject_4 = (0, tslib_1.__makeTemplateObject)(["\n  max-height: ", ";\n  overflow-x: hidden;\n"], ["\n  max-height: ", ";\n  overflow-x: hidden;\n"])), function (_a) {
    var maxHeight = _a.maxHeight;
    return (maxHeight ? "".concat(maxHeight, "px") : 'none');
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=search-result-list.js.map